import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  DropDownWithButton,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../common-components";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const CreatePostModal = ({
  display,
  setCreatePostModal,
  refresh,
  setRefresh,
  setLoading,
  auth,
  setMessage,
  setToastPop,
  setPopUpTitle,
  companyInformation,
}) => {
  const [selectedPostType, setSelectedPostType] = useState(
    "CLICK HERE TO SELECT POST OPTIONS"
  );
  const [subSelectionPostType, setSubSelectionPostType] = useState(
    "CLICK HERE TO SELECT A POST GROUP"
  );

  const ReturnPostSubType = () => {
    if (selectedPostType === "BOLO") {
      return ["STOLEN VEHICLE", "HIJACKING", "MISSING PERSON", "KIDNAPPING"];
    } else if (selectedPostType === "WEATHER") {
      return [
        "HEAVY RAIN",
        "STRONG WINDS",
        "SNOW | HAIL",
        "HIGH | LOW TEMPERATURE",
      ];
    } else if (selectedPostType === "TRAFFIC") {
      return [
        "SLOW TRAFFIC",
        "ACCIDENT",
        "ROAD CLOSURE",
        "PROTEST | LOOTING | HEIST",
      ];
    } else if (selectedPostType === "VEHICLE") {
      return ["VEHICLE LAUNCH", "SALE", "RECALL", "AFTER MARKET PRODUCTS"];
    } else {
      return ["ANNOUNCEMENTS", "EVENTS"];
    }
  };
  const [title, setTitle] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [sourceLink, setSourceLink] = useState("");
  const [tags, setTags] = useState("");
  const [imageData, setImageData] = useState(null);

  const [file, setFile] = useState(null);

  const [imageError, setImageError] = useState("");

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };

  const ClearData = () => {
    setTitle("");
    setShortDescription("");
    setLongDescription("");
    setSourceLink("");
    setTags("");
    setSubSelectionPostType("CLICK HERE TO SELECT A POST GROUP");
    setSelectedPostType("CLICK HERE TO SELECT POST OPTIONS");
    setFile(null);
  };

  const CreateTagsArray = () => {
    const TagsArray = tags.split(" ");

    return TagsArray;
  };

  const CreatenewPost = async (e) => {
    setLoading(true);

    if (!validFileTypes.find((type) => type === file.type)) {
      setImageError("File type must be JPG or PNG format");
      return;
    } else {
      setImageError("");
      setImageData(file);
    }
    try {
      const postArray = [`${selectedPostType}`, `${subSelectionPostType}`];
      const formData = new FormData();
      formData.append("image", file);
      formData.append("title", title);
      formData.append("senderId", companyInformation._id);
      formData.append(
        "senderDetails",
        companyInformation.companyName +
          " - " +
          auth.firstName +
          " " +
          auth.lastName
      );
      formData.append("status", "PENDING");
      formData.append("shortDescription", longDescription.substring(0, 50));
      formData.append("longDescription", longDescription);
      formData.append("postType", postArray);
      formData.append("tags", CreateTagsArray());
      formData.append("sourceLink", sourceLink);
      formData.append(
        "creationApprovedBy",
        auth.firstName + " " + auth.lastName
      );
      formData.append("editedBy", auth.firstName + " " + auth.lastName);

      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/buzzPost/createPost",
        {
          method: "POST",
          body: formData,
        }
      );
      const respnseData = await response.json();
      console.log("response", respnseData);
      if (respnseData.success) {
        setCreatePostModal(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setRefresh(refresh ? false : true);
        ClearData();
        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };
  useEffect(() => {
    setSubSelectionPostType("CLICK HERE TO SELECT A POST GROUP");
  }, [selectedPostType]);
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        height: display ? "100%" : 0,
        width: "100%",
        backgroundColor: colors.white,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.3s",
        zIndex: 300,
      }}
    >
      <div style={{ position: "absolute", top: 10, left: 10 }}>
        <BaseButtons
          label={"X"}
          borderRadius={8}
          backgroundColor={colors.secondaryDarkBlue}
          width={40}
          onClick={() => {
            setCreatePostModal(false);
            ClearData();
          }}
        />
      </div>
      <div style={{ position: "absolute", top: 10, right: 10 }}>
        <BaseButtons
          label={"UPLOAD POST"}
          borderRadius={8}
          backgroundColor={colors.greenLight}
          width={130}
          onClick={() => CreatenewPost()}
        />
      </div>
      <div style={{ position: "absolute", top: 20, left: 140 }}>
        <div style={{ fontWeight: "bold", fontSize: 20 }}>UPLOAD NEW POST</div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          flex: 1,
        }}
      >
        <div
          style={{
            flex: 0.5,
            height: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ marginTop: 70, marginLeft: 20 }}>
            <TextInputField
              mini={true}
              labelTitle={"TITLE"}
              //   width={"100%"}
              size={350}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <TextInputField
              mini={true}
              labelTitle={"SENDER DETAILS (AUTO GENERATED)"}
              readOnly={true}
              size={350}
              value={
                companyInformation && auth
                  ? companyInformation.companyName +
                    " - " +
                    auth.firstName +
                    " " +
                    auth.lastName
                  : "loading"
              }
            />
            {/* <TextInputFieldArea
              mini={true}
              labelTitle={"SHORT DESCRIPTION"}
              // readOnly={true}
              reqiredCheck={true}
              rule={shortDescription.length}
              count={80}
              height={80}
              size={350}
              value={shortDescription}
              onChange={(e) => setShortDescription(e.target.value)}
            /> */}
            <TextInputFieldArea
              mini={true}
              labelTitle={"LONG DESCRIPTION"}
              // readOnly={true}
              reqiredCheck={true}
              rule={longDescription.length}
              count={200}
              height={130}
              size={350}
              value={longDescription}
              onChange={(e) => setLongDescription(e.target.value)}
            />
          </div>
        </div>
        <div
          style={{
            flex: 0.5,
            height: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ marginTop: 70, marginLeft: 20 }}>
            <TextInputField
              mini={true}
              labelTitle={"TAGS"}
              //   width={"100%"}
              size={350}
              value={tags}
              onChange={(e) => setTags(e.target.value)}
            />
            <TextInputField
              mini={true}
              labelTitle={"SOURCE LINK"}
              //   width={"100%"}
              size={350}
              value={sourceLink}
              onChange={(e) => setSourceLink(e.target.value)}
            />
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                marginTop: 40,
                justifyContent: "center",
              }}
            >
              <div style={{ flex: 0.3 }}>
                <CheckInput
                  label={"BOLO"}
                  selected={selectedPostType === "BOLO" ? true : false}
                  onClick={() =>
                    setSelectedPostType(
                      selectedPostType === "BOLO"
                        ? "CLICK HERE TO SELECT POST OPTIONS"
                        : "BOLO"
                    )
                  }
                />
              </div>
              <div style={{ flex: 0.3 }}>
                <CheckInput
                  label={"WEATHER"}
                  selected={selectedPostType === "WEATHER" ? true : false}
                  onClick={() =>
                    setSelectedPostType(
                      selectedPostType === "WEATHER"
                        ? "CLICK HERE TO SELECT POST OPTIONS"
                        : "WEATHER"
                    )
                  }
                />
              </div>
              <div style={{ flex: 0.3 }}>
                <CheckInput
                  label={"TRAFFIC"}
                  selected={selectedPostType === "TRAFFIC" ? true : false}
                  onClick={() =>
                    setSelectedPostType(
                      selectedPostType === "TRAFFIC"
                        ? "CLICK HERE TO SELECT POST OPTIONS"
                        : "TRAFFIC"
                    )
                  }
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                marginTop: 40,
                justifyContent: "center",
              }}
            >
              <div style={{ flex: 0.3 }}>
                <CheckInput
                  label={"VEHICLE"}
                  selected={selectedPostType === "VEHICLE" ? true : false}
                  onClick={() =>
                    setSelectedPostType(
                      selectedPostType === "VEHICLE"
                        ? "CLICK HERE TO SELECT POST OPTIONS"
                        : "VEHICLE"
                    )
                  }
                />
              </div>
              <div style={{ flex: 0.3 }}>
                <CheckInput
                  label={"GENERAL"}
                  selected={selectedPostType === "GENERAL" ? true : false}
                  onClick={() =>
                    setSelectedPostType(
                      selectedPostType === "GENERAL"
                        ? "CLICK HERE TO SELECT POST OPTIONS"
                        : "GENERAL"
                    )
                  }
                />
              </div>
            </div>
            {selectedPostType !== "CLICK HERE TO SELECT POST OPTIONS" ? (
              <DropDownWithButton
                data={ReturnPostSubType()}
                title={subSelectionPostType}
                setSelectedItem={setSubSelectionPostType}
                width={300}
              />
            ) : null}
            <div />
            <div style={{ height: 30 }} />
            <ImageUploadAWS
              onChange={(e) => handleFileChange(e)}
              labelTitle={"UPLOAD IMAGE"}
              mini={true}
              errorDisplay={imageError}
            />
            <div style={{ marginTop: 20, textAlign: "center", opacity: 0.6 }}>
              POST TOO SELECTION COMING SOON{" "}
            </div>
            <div style={{ textAlign: "center", opacity: 0.9, marginTop: 20 }}>
              ALL POSTS WILL BE FOR GENERAL VIEW
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePostModal;
